import { useState } from "react";
import { saveExchangeRate, getExchangeRateTypes } from "../Api/ExchangeRate";
import { Container, Form, Button, Row, Col, Accordion } from "react-bootstrap";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Sample14 from "../Components/Logo";

const ExchangeRate = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const userId = userDetails?.userId;

  const [exchangeRateData, setExchangeRateData] = useState({
    fromCurrency: "",
    toCurrency: "",
    exchangeRateType: "M",
    validFrom: "",
    rate: "",
    currencyUnit: "",
  });

  const exchangeRateTypes = getExchangeRateTypes();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setExchangeRateData({
      ...exchangeRateData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!userId) {
      toast.error("User not authenticated");
      return;
    }

    setLoading(true);
    try {
      await saveExchangeRate(exchangeRateData, userId);
      toast.success("🦄 Exchange Rate Added Successfully");

      setExchangeRateData({
        fromCurrency: "",
        toCurrency: "",
        exchangeRateType: "M",
        validFrom: "",
        rate: "",
        currencyUnit: "",
      });

      navigate("/viewExchangeRate");
    } catch (error) {
      toast.error(`🦄 Error: ${error.message || "Failed to save exchange rate"}`);
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="main-content expand">
        <Container fluid className="fields-container">
          <h2 className="fields-title">Exchange Rate</h2>

          <Form onSubmit={handleSubmit} className="fields-form">

            <Accordion defaultActiveKey="0">

              <Accordion.Item eventKey="0">

                

                <Accordion.Body>

                  <Row>
                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          From Currency <span className="text-red">**</span>
                        </Form.Label>

                        <Form.Control
                          type="text"
                          name="fromCurrency"
                          value={exchangeRateData.fromCurrency}
                          onChange={handleChange}
                          required
                        />
                      </Form.Group>
                    </Col>

                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          To Currency <span className="text-red">**</span>
                        </Form.Label>

                        <Form.Control
                          type="text"
                          name="toCurrency"
                          value={exchangeRateData.toCurrency}
                          onChange={handleChange}
                          required
                        />
                      </Form.Group>
                    </Col>

                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          Exchange Rate Type <span className="text-red">**</span>
                        </Form.Label>

                        <Form.Select
                          name="exchangeRateType"
                          value={exchangeRateData.exchangeRateType}
                          onChange={handleChange}
                          required
                        >
                          {exchangeRateTypes.map((type) => (
                            <option key={type.value} value={type.value}>
                              {type.label}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>

                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          Valid From <span className="text-red">**</span>
                        </Form.Label>

                        <Form.Control
                          type="date"
                          name="validFrom"
                          value={exchangeRateData.validFrom}
                          onChange={handleChange}
                          required
                        />
                      </Form.Group>
                    </Col>

                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          Exchange Rate <span className="text-red">**</span>
                        </Form.Label>

                        <Form.Control
                          type="number"
                          name="rate"
                          value={exchangeRateData.rate}
                          onChange={handleChange}
                          required
                          step="0.01"
                        />
                      </Form.Group>
                    </Col>

                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          Currency Unit <span className="text-red">**</span>
                        </Form.Label>

                        <Form.Control
                          type="number"
                          name="currencyUnit"
                          value={exchangeRateData.currencyUnit}
                          onChange={handleChange}
                          required
                        />
                      </Form.Group>
                    </Col>

                  </Row>

                </Accordion.Body>

              </Accordion.Item>

            </Accordion>

            <div className="fields-btn-container">
              <Button variant="primary" type="submit" className="fields-submit">
                Save Exchange Rate
              </Button>
            </div>

          </Form>
        </Container>
      </div>

      {loading && (
        <div className="loading-overlay">
          <Sample14 />
        </div>
      )}
    </>
  );
};

export default ExchangeRate;